// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
   production: false,

   BASE_API_URL: 'http://83.56.25.97/master.hometech.red/api/index.php',
   //  BASE_API_URL: 'http://89.7.222.195/master1.hometech.red/api/index.php',

  BASE_APP_URL: 'http://teho.hometech.red:12578/',
   //  BASE_APP_URL: 'http://192.168.1.200:4200/',

    BASE_FILE_URL: 'http://83.56.25.97/ideacomonjas_rudy',
  // BASE_FILE_URL: 'http://89.7.222.195/ideacomonjas_rudy',
   // BASE_FILE_URL: 'http://ideacomonjas-rudy.hometech.red',

   /*
    * Esta variable nos indica que notificaciones vamos a recibir
    */
   TOPIC_NOTIFICACION: 'teho1',

   ID_RC: 'finca',
   NEMO_RC: 'teho.finca',

   NEMO_RC_PORTERO1: 'portero1.finca',
   NEMO_RC_PORTERO2: 'portero2.finca',

   CONFERENCIA1: 'ekeeper1',
   CONFERENCIA2: 'ekeeper2',

   //  IP_SERVIDOR_SIGNALLING: '89.7.222.195',
   // IP_SERVIDOR_SIGNALLING: '192.168.1.100',
   IP_SERVIDOR_SIGNALLING: '83.56.25.97',
   PUERTO_SERVIDOR_SIGNALLING: '9000',

   // IP_SERVIDOR_ADMIN: '89.7.222.195',
   IP_SERVIDOR_ADMIN: '83.56.25.97',
   PUERTO_SERVIDOR_ADMIN: '3000',

   APP_SEMI_KEY: '5JTx6s8'
 };

 /*
  * For easier debugging in development mode, you can import the following file
  * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
  *
  * This import should be commented out in production mode because it will have a negative impact
  * on performance if an error is thrown.
  */
 // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
